module.exports = __webpack_public_path__ + "img/IMG_5895.f10e7065.jpg";